import { render, staticRenderFns } from "./PageHRDocumentEdit.vue?vue&type=template&id=4de35a70&"
import script from "./PageHRDocumentEdit.vue?vue&type=script&lang=js&"
export * from "./PageHRDocumentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports